import React, { useEffect, useState } from "react";
import moment from "moment";
import AlignerImage from "./../assets/aligner.png";
import { useNavigate } from "react-router";
import {
  HEADER_COLOR,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  TERTIARY_COLOR,
} from "../constants/theme";
import { toast } from "react-toastify";
import { getPatientCaseData } from "../services/patient/patient.service";
import Loader from "../components/Loader";
import { getAlignerScheduleByCaseId } from "../services/alignerSchedule/alignerSchedule.service";

const AlignerSchedule = () => {
  const navigate = useNavigate();

  const email = sessionStorage.getItem("email");
  const clinicCode = sessionStorage.getItem("clinicCode")
    ? JSON.parse(sessionStorage.getItem("clinicCode"))[0]?.clinic_code
    : "";

  const patientId = sessionStorage.getItem("patientId");

  const [loading, setLoading] = useState(false);
  const [alignerData, setAlignerData] = useState(undefined);
  const [screenWidth, setScreenWidth] = useState(0);
  const [allPatientCases, setAllPatientCase] = useState([]);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const getPatientCases = async () => {
    try {
      setLoading(true);

      if (!clinicCode) {
        return toast.error("No associated clinic found. Contact support!");
      }
      if (!patientId) {
        toast.error("Data error! Login again!");
        sessionStorage.clear();
        navigate("/login");
        return;
      }
      const response = await getPatientCaseData(email, patientId, "1", 0);
      if (response.status === 200) {
        setAllPatientCase(response.data.data);
        // setLatestCase(response?.data?.data[0]);
        const alignerScheduleRes = await getAlignerScheduleByCaseId(
          email,
          response?.data?.data[0].case_id
        );
        if (
          alignerScheduleRes.status === 200 &&
          alignerScheduleRes.data.status === 200
        ) {
          setAlignerData(alignerScheduleRes.data.data);
        }
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("ERROR FETCHING PATIENT CASE DATA => ", error);
      return toast("Server error. Try again later!");
    }
  };

  useEffect(() => {
    getPatientCases();
  }, []);

  return (
    <div className="position-relative col-12 p-0" style={{ zIndex: "20" }}>
      <div className="row w-100 mx-auto flex-column align-items-center justify-content-between">
        <div className="col-12 p-0">
          <div
            className=""
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              // padding: "13px 13px 32px 13px",
              marginLeft: "10px",
              marginRight: "10px",
              borderRadius: "15px",
              overflowY: "scroll",
              height: "90vh",
              scrollBehavior: "smooth",
            }}
          >
            <div
              className="row w-100 mx-auto"
              style={{
                marginTop: "18px",
                lineHeight: "1.1",
                gap: "22px",
              }}
            >
              {loading && <Loader />}
              {!loading &&
                (!alignerData ||
                  (alignerData && alignerData?.total_steps === 0)) && (
                  <div>No data found!</div>
                )}
              {!loading && alignerData && alignerData.total_steps > 0 && (
                <>
                  <div
                    className="text-center"
                    style={{
                      color: PRIMARY_COLOR,
                    }}
                  >
                    <h5>Total Steps: {alignerData?.total_steps}</h5>
                  </div>
                  <hr />
                </>
              )}
              {!loading && alignerData && alignerData.total_steps > 0 && (
                <div
                  className="text-center"
                  style={{
                    color: SECONDARY_COLOR,
                  }}
                >
                  <h6>
                    Aligners Steps:{" "}
                    {Math.max(
                      alignerData?.aligners_lower_quantity,
                      alignerData?.aligners_upper_quantity
                    )}
                  </h6>
                </div>
              )}
              {!loading &&
                alignerData &&
                alignerData.total_steps > 0 &&
                Array.from({
                  length: Math.max(
                    alignerData?.aligners_lower_quantity,
                    alignerData?.aligners_upper_quantity
                  ),
                }).map((item, index) => {
                  let switchAligner = true;

                  return (
                    <div className="col-12 px-sm-4" key={index}>
                      <div
                        className="mx-auto card-hover-effect"
                        style={{
                          padding: "14px 6px 14px 14px",
                          backgroundColor: "rgb(203, 108, 230)",
                          borderRadius: "16px",
                          gap: "12px",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: screenWidth <= 480 ? "column" : "",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          textAlign: "center",
                        }}
                        // onClick={(e) => {
                        //   sessionStorage.setItem(
                        //     "caseHistory",
                        //     JSON.stringify(allPatientCases)
                        //   );
                        //   sessionStorage.setItem(
                        //     "switchData",
                        //     JSON.stringify({
                        //       step: index + 1,
                        //       type: "aligner",
                        //       alignerSchedule: alignerData,
                        //     })
                        //   );
                        //   navigate("/switch-aligners");
                        // }}
                      >
                        <div
                          className={`col-${
                            screenWidth <= 480
                              ? "12 d-flex justify-content-center"
                              : "auto"
                          } p-0`}
                        >
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              height: "50px",
                              width: "50px",
                            }}
                          >
                            <img
                              className="w-100"
                              src={AlignerImage}
                              alt="aligner"
                              style={{}}
                            />
                          </div>
                        </div>

                        <div
                          className={`col${
                            screenWidth <= 480 ? "-12" : ""
                          } p-0`}
                        >
                          <div
                            className="d-flex flex-column justify-content-center"
                            style={{
                              fontSize: "17px",
                              color: "#ffffff",
                              gap: "4px",
                              maxWidth: screenWidth <= 480 ? "" : "190px",
                              minWidth: screenWidth <= 480 ? "" : "180px",
                            }}
                          >
                            <div className="" style={{}}>
                              Aligner Number: {index + 1}
                            </div>
                            <div
                              className=""
                              style={{
                                fontSize: "10px",
                                lineHeight: "1.25",
                              }}
                            >
                              {alignerData?.aligners_upper_quantity >= index + 1
                                ? `Upper`
                                : null}{" "}
                              {alignerData?.aligners_upper_quantity >=
                                index + 1 &&
                              alignerData?.aligners_lower_quantity >= index + 1
                                ? "+"
                                : null}{" "}
                              {alignerData?.aligners_lower_quantity >= index + 1
                                ? `Lower`
                                : null}
                            </div>
                          </div>
                        </div>

                        <div
                          className={`col${
                            screenWidth <= 480 ? "-12" : ""
                          } p-0`}
                        >
                          <div
                            className="d-flex flex-column justify-content-center"
                            style={{
                              fontSize: "17px",
                              color: "#ffffff",
                              gap: "4px",
                              maxWidth: screenWidth <= 480 ? "" : "190px",
                              minWidth: screenWidth <= 480 ? "" : "180px",
                            }}
                          >
                            {alignerData?.before_aligner_pictures &&
                            alignerData?.before_aligner_pictures.length > 0 &&
                            alignerData?.before_aligner_pictures.find(
                              (item) => item.step === index + 1
                            ) ? (
                              <button
                                className="btn"
                                style={{
                                  background: TERTIARY_COLOR,
                                  color: "black",
                                }}
                                onClick={() => {
                                  sessionStorage.setItem(
                                    "caseHistory",
                                    JSON.stringify(allPatientCases)
                                  );
                                  sessionStorage.setItem(
                                    "switchData",
                                    JSON.stringify({
                                      step: index + 1,
                                      type: "aligner",
                                      alignerSchedule: alignerData,
                                    })
                                  );
                                  navigate("/view-aligner-plan");
                                }}
                              >
                                View pictures
                              </button>
                            ) : (
                              <button
                                className="btn"
                                style={{
                                  background: TERTIARY_COLOR,
                                  color: "black",
                                }}
                                disabled={!switchAligner}
                                onClick={() => {
                                  sessionStorage.setItem(
                                    "caseHistory",
                                    JSON.stringify(allPatientCases)
                                  );

                                  sessionStorage.setItem(
                                    "switchData",
                                    JSON.stringify({
                                      step: index + 1,
                                      type: "aligner",
                                      alignerSchedule: alignerData,
                                    })
                                  );
                                  navigate("/switch-aligners");
                                }}
                              >
                                Switch now
                              </button>
                            )}
                            {alignerData?.before_aligner_pictures[index] && (
                              <div
                                className=""
                                style={{
                                  fontSize: "10px",
                                  lineHeight: "1.25",
                                }}
                              >
                                {moment(
                                  alignerData?.before_aligner_pictures[index]
                                    ?.date
                                ).format("DD MMM YY")}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

              {!loading && alignerData && alignerData.total_steps > 0 && (
                <div
                  className="text-center"
                  style={{
                    color: SECONDARY_COLOR,
                  }}
                >
                  <h6>
                    Retainer Steps:{" "}
                    {Math.max(
                      alignerData?.retainer_upper_quantity,
                      alignerData?.retainer_lower_quantity
                    )}
                  </h6>
                </div>
              )}
              {!loading &&
                alignerData &&
                alignerData.total_steps > 0 &&
                Array.from({
                  length: Math.max(
                    alignerData?.retainer_upper_quantity,
                    alignerData?.retainer_lower_quantity
                  ),
                }).map((item, index) => {
                  let switchAligner = true;
                  // if (
                  //   alignerData.alignerBeforePictures.length ===
                  //     alignerData.alignerLower &&
                  //   index === 0 &&
                  //   alignerData.retainerBeforePictures.length === 0
                  // ) {
                  //   switchAligner = true;
                  // } else if (
                  //   index + 1 ===
                  //   alignerData.alignerBeforePictures.length
                  // ) {
                  //   switchAligner = true;
                  // }
                  return (
                    <div className="col-12 px-sm-4" key={index}>
                      <div
                        className="mx-auto card-hover-effect"
                        style={{
                          padding: "14px 6px 14px 14px",
                          backgroundColor: "rgb(203, 108, 230)",
                          borderRadius: "16px",
                          gap: "12px",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: screenWidth <= 480 ? "column" : "",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          textAlign: "center",
                        }}
                      >
                        <div
                          className={`col-${
                            screenWidth <= 480
                              ? "12 d-flex justify-content-center"
                              : "auto"
                          } p-0`}
                        >
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              height: "50px",
                              width: "50px",
                            }}
                          >
                            <img
                              className="w-100"
                              src={AlignerImage}
                              alt="aligner"
                              style={{}}
                            />
                          </div>
                        </div>

                        <div
                          className={`col${
                            screenWidth <= 480 ? "-12" : ""
                          } p-0`}
                        >
                          <div
                            className="d-flex flex-column justify-content-center"
                            style={{
                              fontSize: "17px",
                              color: "#ffffff",
                              gap: "4px",
                              maxWidth: screenWidth <= 480 ? "" : "190px",
                              minWidth: screenWidth <= 480 ? "" : "180px",
                            }}
                          >
                            <div className="" style={{}}>
                              Retainer Number: {index + 1}
                            </div>
                            <div
                              className=""
                              style={{
                                fontSize: "10px",
                                lineHeight: "1.25",
                              }}
                            >
                              {alignerData?.retainer_upper_quantity >= index + 1
                                ? `Upper`
                                : null}{" "}
                              {alignerData?.retainer_upper_quantity >=
                                index + 1 &&
                              alignerData?.retainer_lower_quantity >= index + 1
                                ? "+"
                                : null}{" "}
                              {alignerData?.retainer_lower_quantity >= index + 1
                                ? `Lower`
                                : null}
                            </div>
                          </div>
                        </div>

                        <div
                          className={`col${
                            screenWidth <= 480 ? "-12" : ""
                          } p-0`}
                        >
                          <div
                            className="d-flex flex-column justify-content-center"
                            style={{
                              fontSize: "17px",
                              color: "#ffffff",
                              gap: "4px",
                              maxWidth: screenWidth <= 480 ? "" : "190px",
                              minWidth: screenWidth <= 480 ? "" : "180px",
                            }}
                          >
                            {alignerData?.before_aligner_pictures &&
                            alignerData?.before_aligner_pictures.length > 0 &&
                            alignerData?.before_aligner_pictures.find(
                              (item) =>
                                item.step ===
                                Math.max(
                                  alignerData?.aligners_lower_quantity,
                                  alignerData?.aligners_upper_quantity
                                ) +
                                  index +
                                  1
                            ) ? (
                              <button
                                className="btn"
                                style={{
                                  background: TERTIARY_COLOR,
                                  color: "black",
                                }}
                                disabled
                                onClick={() => {
                                  sessionStorage.setItem(
                                    "caseHistory",
                                    JSON.stringify(allPatientCases)
                                  );

                                  sessionStorage.setItem(
                                    "switchData",
                                    JSON.stringify({
                                      step:
                                        Math.max(
                                          alignerData?.aligners_lower_quantity,
                                          alignerData?.aligners_upper_quantity
                                        ) +
                                        index +
                                        1,
                                      type: "retainer",
                                      alignerSchedule: alignerData,
                                    })
                                  );
                                  navigate("/view-aligner-plan");
                                }}
                              >
                                View pictures
                              </button>
                            ) : (
                              <button
                                className="btn"
                                style={{
                                  background: TERTIARY_COLOR,
                                  color: "black",
                                }}
                                disabled={!switchAligner}
                                onClick={() => {
                                  sessionStorage.setItem(
                                    "caseHistory",
                                    JSON.stringify(allPatientCases)
                                  );

                                  sessionStorage.setItem(
                                    "switchData",
                                    JSON.stringify({
                                      step:
                                        Math.max(
                                          alignerData?.aligners_lower_quantity,
                                          alignerData?.aligners_upper_quantity
                                        ) +
                                        index +
                                        1,
                                      type: "retainer",
                                      alignerSchedule: alignerData,
                                    })
                                  );
                                  navigate("/switch-aligners");
                                }}
                              >
                                Switch now
                              </button>
                            )}
                            {alignerData?.before_aligner_pictures[
                              Math.max(
                                alignerData?.aligners_lower_quantity,
                                alignerData?.aligners_upper_quantity
                              ) + index
                            ] && (
                              <div
                                className=""
                                style={{
                                  fontSize: "10px",
                                  lineHeight: "1.25",
                                }}
                              >
                                {moment(
                                  alignerData?.before_aligner_pictures[
                                    Math.max(
                                      alignerData?.aligners_lower_quantity,
                                      alignerData?.aligners_upper_quantity
                                    ) + index
                                  ]?.date
                                ).format("DD MMM YY")}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlignerSchedule;
